
const Sidebar = ({ selections, restartFn }) => {
  const hasSelections = selections && selections.length > 0

  return (
    <div>

      { hasSelections && (
        <div className="selection-sidebar">My selections</div>
      )}

      { hasSelections && (
        selections.map(selection => (
          <Selection key={selection} selection={selection} />
        ))
      )}

      { hasSelections && (
        <button className="btn-restart" onClick={ () => restartFn({ choice: "reset" }) }>Reset</button>
      )}
    </div>
  )
}

const Selection = ({ selection }) => {
  const image_url = `/assets/${selection}_selection.png`
  const selection_text = selection.replace(/_/g, " ")

  return (
    <div className="selection-sidebar-item row">

      <div className="sidebar-image"><img src={ image_url } className="img-responsive center-block" width="50px" /></div>

      <div className="sidebar-item"><span>{ selection_text }</span></div>

    </div>
  )
}

export default Sidebar
